module.exports = __webpack_public_path__ + "img/product.599bcb66.svg";